module.exports = __webpack_public_path__ + "static/media/background.74ba73f0.png";